import { render } from "./VisitorGatepassView.vue?vue&type=template&id=2af3639a&scoped=true"
import script from "./VisitorGatepassView.vue?vue&type=script&lang=js"
export * from "./VisitorGatepassView.vue?vue&type=script&lang=js"

import "./VisitorGatepassView.vue?vue&type=style&index=0&id=2af3639a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af3639a"]])

export default __exports__